import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Authentication from './Authentication';
export default (authProps) => (ChildComponent) => (props) => (_jsx(Authentication, Object.assign({}, authProps, { children: _jsx(ChildComponent, Object.assign({}, props)) })));
export const AuthenticationCustomHoc = (cb) => (ChildComponent) => (props) => (_jsx(Authentication, Object.assign({}, cb(props), { children: _jsx(ChildComponent, Object.assign({}, props)) })));
